import { render, staticRenderFns } from "./ShareProfile.vue?vue&type=template&id=8c54dc8a&"
import script from "./ShareProfile.vue?vue&type=script&lang=ts&"
export * from "./ShareProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ShareProfile.vue?vue&type=style&index=0&id=8c54dc8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports